const tagColors = [
	{
		backgroundColor: '#FFF5E7',
		color: '#A86020'
	},
	{
		backgroundColor: '#f2eaff',
		color: '#5b2891'
	},
	{
		backgroundColor: '#ffe7f9',
		color: '#831a57'
	},
	{
		backgroundColor: '#e9fefd',
		color: '#1d7873'
	},
	{
		backgroundColor: '#fffce9',
		color: '#a37c18'
	},
	{
		backgroundColor: '#f8ffeb',
		color: '#1d7873'
	},
	{
		backgroundColor: '#FFF5E7',
		color: '#A86020'
	},
	{
		backgroundColor: '#Eafcf1',
		color: '#456a52'
	},
	{
		backgroundColor: '#e9f4ff',
		color: '#356384'
	},
	{
		backgroundColor: '#f2eaff',
		color: '#5b2891'
	},
	{
		backgroundColor: '#ffe7f9',
		color: '#831a57'
	},
];

module.exports = {
	tagColors
}